/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useCallback, useEffect, useState } from 'react'

import { Button, Col, Form, Input, PageHeader, Radio, Row, Table } from 'antd'
import { SelectFieldAnt } from 'Components/Form'
import { SelectItemProps } from 'Components/Form/Select'
import { useExportReport } from 'Hooks/useExportReport'
import AreaGeografica from 'Models/cadastros/AreaGeografica'
import Nominatim from 'Models/cadastros/Nominatim'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import { ServiceListResponse } from 'Types/ServiceResponse'

import IFormAreasGeograficasFilter from './IFormAreasGeograficasFilter'

const ListAreasGeograficas: FC = () => {
  const navigate = useNavigate()
  const hookForm = useForm()
  const [dataItens, setDataItens] = useState<
    ServiceListResponse<AreaGeografica> | undefined
  >()
  const [tipoArea, setTipoArea] = useState<string>('pais')
  const [cdLocalSelecionado, setCdLocalSelecionado] = useState<number>()
  const [cdPais, setCdPais] = useState<number>()
  const [cdUF, setCdUF] = useState<number>()
  const [cdCidade, setCdCidade] = useState<number>()
  const [nominatim, setNominatim] = useState<Nominatim[]>([])
  const [selectPaisItens, setSelectPaisItens] = useState<SelectItemProps[]>([])
  const [selectUfItens, setSelectUfItens] = useState<SelectItemProps[]>([])
  const [selectCidadeItens, setSelectCidadeItens] = useState<SelectItemProps[]>(
    [],
  )
  const [selectBairroItens, setSelectBairroItens] = useState<SelectItemProps[]>(
    [],
  )
  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)
  const [carregandoExportacao, setCarregandoExportacao] =
    useState<boolean>(false)
  const [formulario] = Form.useForm<IFormAreasGeograficasFilter>()
  const [alturaTabela, setAlturaTabela] = useState<number>(
    window.innerHeight - 425,
  )

  window.addEventListener('resize', () =>
    setAlturaTabela(window.innerHeight - 425),
  )

  const colunas = [
    {
      title: 'Nome',
      key: 'nome',
      dataIndex: 'nome',
    },
    {
      title: 'Área',
      key: 'lugar',
      dataIndex: 'lugar',
    },
    {
      title: 'Situação',
      key: 'ativo',
      dataIndex: 'ativo',
      render: (ativo: boolean) => (ativo ? 'ATIVO' : 'INATIVO'),
    },
  ]

  const getPaises = useCallback(async () => {
    const { data } = await WsCadastroService.geo.getListNominatim('pais')

    if (data) {
      setNominatim(data)

      const selectPaisData: SelectItemProps[] = data.map(
        (item: Nominatim): SelectItemProps => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        },
      )

      setSelectPaisItens(selectPaisData)
    }
  }, [])

  const getUFs = useCallback(async (cdPais: number) => {
    const { data } = await WsCadastroService.geo.getListNominatim('uf', {
      cdPais: cdPais,
    })

    if (data) {
      setNominatim(data)

      const selectUfData: SelectItemProps[] = data.map(
        (item: Nominatim): SelectItemProps => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        },
      )

      setSelectUfItens(selectUfData)
    }
  }, [])

  const getCidades = useCallback(async (cdUF: number) => {
    const { data } = await WsCadastroService.geo.getListNominatim('cidade', {
      cdPais: cdPais,
      cdUF: cdUF,
    })

    if (data) {
      setNominatim(data)

      const selectCidadeData: SelectItemProps[] = data.map(
        (item: Nominatim): SelectItemProps => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        },
      )

      setSelectCidadeItens(selectCidadeData)
    }
  }, [])

  const getBairros = useCallback(async (cdCidade: number) => {
    const { data } = await WsCadastroService.geo.getListNominatim('bairro', {
      cdUF: cdUF,
      cdCidade: cdCidade,
    })

    if (data) {
      setNominatim(data)

      const selectBairroData: SelectItemProps[] = data.map(
        (item: Nominatim): SelectItemProps => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        },
      )

      setSelectBairroItens(selectBairroData)
    }
  }, [])

  useEffect(() => {
    getPaises()
  }, [])

  const pesquisaOuExportaAreasGeograficas = async (
    dados: IFormAreasGeograficasFilter,
  ) => {
    const filtros: IFormAreasGeograficasFilter = {
      nome: dados.nome,
      idNominatim: nominatim.find((f) => f.id === cdLocalSelecionado)
        ?.idNominatim,
      ativo: dados.ativo === undefined ? true : dados.ativo,
    }

    if (carregandoPesquisa) {
      const { data } = await WsCadastroService.areasGeograficas.getList(filtros)
      setDataItens(data)
      setCarregandoPesquisa(false)
    } else {
      //await useExportReport.exportXLSX(WsCadastroService.areasGeograficas.export, 'AreasGeograficas', colunas, filtros)
      const colunasParaExportar =
        useExportReport.convertColumnToItemsList(colunas)
      const { data } = await WsCadastroService.areasGeograficas.export(
        filtros,
        undefined,
        { exportItemsList: colunasParaExportar },
      )

      if (data) {
        const a: any = document.createElement('A')
        a.href =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; base64,' +
          data
        a.download = 'Areas Geográficas.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }

      setCarregandoExportacao(false)
    }
  }

  const handleRowClick = (rowData?: AreaGeografica) => {
    navigate('/AreaGeografica/Alterar/' + rowData?.id)
  }

  const alteraPagina = async (numeroPagina: number, tamanhoPagina?: number) => {
    const parametros: ParamsRequest = {
      pageNumber: numeroPagina,
      pageSize: tamanhoPagina ?? 50,
    }

    const { data } = await WsCadastroService.areasGeograficas.getList(
      formulario.getFieldsValue(),
      parametros,
    )
    setDataItens(data)
  }

  const reiniciaDadosUfCidadeBairro = () => {
    formulario.setFieldsValue({
      cdUF: undefined,
      cdCidade: undefined,
      cdBairro: undefined,
    })
    setCdUF(undefined)
    setCdCidade(undefined)
  }

  const reiniciaDadosCidadeBairro = () => {
    formulario.setFieldsValue({ cdCidade: undefined, cdBairro: undefined })
    setCdCidade(undefined)
  }

  const reiniciaDadosBairro = () => {
    formulario.setFieldsValue({ cdBairro: undefined })
  }

  return (
    <>
      <Form
        onFinish={pesquisaOuExportaAreasGeograficas}
        layout="vertical"
        form={formulario}
      >
        <PageHeader
          ghost={false}
          title="Consultar Area Geográfica"
          extra={[
            <Button
              key="pesquisa"
              type="primary"
              htmlType="submit"
              loading={carregandoPesquisa}
              onClick={() => setCarregandoPesquisa(true)}
            >
              Pesquisar
            </Button>,

            <Button
              key="exportacao"
              type="primary"
              htmlType="submit"
              loading={carregandoExportacao}
              onClick={() => setCarregandoExportacao(true)}
            >
              Exportar
            </Button>,

            <Button
              key="inclusao"
              type="primary"
              onClick={() => navigate('/AreaGeografica/Incluir')}
            >
              Incluir
            </Button>,

            <Button key="ajuda" type="primary">
              ?
            </Button>,
          ]}
        >
          <Row gutter={16}>
            <Col span={8} md={8} sm={12} xs={24}>
              <Form.Item name="nome" label="Nome:">
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={8} md={8} sm={12} xs={24}>
              <SelectFieldAnt
                defaultValue="pais"
                methods={hookForm}
                scope="form-areas-geograficas"
                label="Tipo:"
                name="tipo"
                items={[
                  { value: 'pais', label: 'País' },
                  { value: 'uf', label: 'UF' },
                  { value: 'cidade', label: 'Cidade' },
                  { value: 'bairro', label: 'Bairro' },
                ]}
                showSearch={true}
                onChangeValue={(tipo: string) => {
                  setTipoArea(tipo)

                  if (tipo === 'pais') {
                    reiniciaDadosUfCidadeBairro()
                    getPaises()
                  } else if (tipo === 'uf') {
                    reiniciaDadosCidadeBairro()

                    if (cdPais) {
                      getUFs(cdPais)
                    }
                  } else if (tipo === 'cidade') {
                    reiniciaDadosBairro()

                    if (cdUF) {
                      getCidades(cdUF)
                    }
                  } else if (cdCidade) {
                    getBairros(cdCidade)
                  }
                }}
              />
            </Col>

            <Col span={8} md={8} sm={12} xs={24}>
              <Form.Item name="ativo" label="Situação:">
                <Radio.Group defaultValue={true}>
                  <Radio value={true}>Ativo</Radio>
                  <Radio value={false}>Inativo</Radio>
                  <Radio value={null}>Ambos</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={6} md={6} sm={12} xs={24}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-areas-geograficas"
                label="País:"
                name="cdPais"
                items={selectPaisItens}
                showSearch={true}
                onChangeValue={(cdPaisString: string) => {
                  const cdPais: number = parseInt(cdPaisString)
                  setCdPais(cdPais)

                  if (tipoArea === 'pais') {
                    setCdLocalSelecionado(cdPais)
                  } else {
                    getUFs(cdPais)
                  }

                  reiniciaDadosUfCidadeBairro()
                }}
              />
            </Col>

            <Col span={6} md={6} sm={12} xs={24}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-areas-geograficas"
                label="UF:"
                name="cdUF"
                items={selectUfItens}
                showSearch={true}
                onChangeValue={(cdUfString: string) => {
                  const cdUF: number = parseInt(cdUfString)
                  setCdUF(cdUF)

                  if (tipoArea === 'uf') {
                    setCdLocalSelecionado(cdUF)
                  } else {
                    getCidades(cdUF)
                  }

                  reiniciaDadosCidadeBairro()
                }}
                disabled={tipoArea === 'pais' || !cdPais}
              />
            </Col>

            <Col span={6} md={6} sm={12} xs={24}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-areas-geograficas"
                label="Cidade:"
                name="cdCidade"
                items={selectCidadeItens}
                showSearch={true}
                onChangeValue={(cdCidadeString: string) => {
                  const cdCidade: number = parseInt(cdCidadeString)
                  setCdCidade(cdCidade)

                  if (tipoArea === 'cidade') {
                    setCdLocalSelecionado(cdCidade)
                  } else {
                    getBairros(cdCidade)
                  }

                  reiniciaDadosBairro()
                }}
                disabled={tipoArea === 'pais' || tipoArea === 'uf' || !cdUF}
              />
            </Col>

            <Col span={6} md={6} sm={12} xs={24}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-areas-geograficas"
                label="Bairro:"
                name="cdBairro"
                items={selectBairroItens}
                showSearch={true}
                onChangeValue={(cdBairro: string) =>
                  setCdLocalSelecionado(parseInt(cdBairro))
                }
                disabled={tipoArea !== 'bairro' || !cdCidade}
              />
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Table
                columns={colunas}
                dataSource={dataItens?.items || []}
                scroll={{ y: alturaTabela }}
                onRow={(rowData: AreaGeografica) => {
                  return {
                    onClick: () => handleRowClick(rowData),
                  }
                }}
                pagination={{
                  pageSize: dataItens?.pagination?.pageSize,
                  total: dataItens?.pagination?.total,
                  onChange: alteraPagina,
                  onShowSizeChange: alteraPagina,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '25', '50', '75', '100'],
                  size: 'default',
                }}
              />
            </Col>
          </Row>
        </PageHeader>
      </Form>
    </>
  )
}

export default ListAreasGeograficas
